import React from "react"
import moment from "moment"
import arrowDown from "../assets/images/icons/arrow-down.svg"
import { store } from "store"

export const formatTenure = (months) => {
  return `${months} Days`
  const years = Math.floor(months / 12)
  const remainingMonths = months % 12

  let result = ""
  if (years > 0) {
    // result += `${years} year${years > 1 ? "s" : ""}`
    result += `${years} y`
  }

  if (remainingMonths > 0) {
    if (result !== "") result += " & "
    // result += `${remainingMonths} month${remainingMonths > 1 ? "s" : ""}`
    result += `${remainingMonths} m`
  }

  return result || "0 months"
}

export const formatAmount = (val) => {
  return new Intl.NumberFormat("en-IN").format(val)
}

export const formatAmountInWords = (num) => {
  if (num === 0) return "Zero"

  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ]

  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ]

  function twoDigits(n) {
    if (n < 20) return ones[n]
    return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "")
  }

  function threeDigits(n) {
    let str = ""
    const hundreds = Math.floor(n / 100)
    const remainder = n % 100

    if (hundreds > 0) {
      str += ones[hundreds] + " Hundred"
      if (remainder > 0) {
        str += " and "
      } else {
        str += " "
      }
    }

    if (remainder > 0) {
      str += twoDigits(remainder)
    }

    return str.trim()
  }

  function numberToWords(n) {
    if (n === 0) return ""
    if (n < 100) return twoDigits(n)
    if (n < 1000) return threeDigits(n)

    let result = ""
    const crore = Math.floor(n / 10000000)
    if (crore > 0) {
      result += numberToWords(crore) + " Crore "
      n %= 10000000
    }

    const lakh = Math.floor(n / 100000)
    if (lakh > 0) {
      result += numberToWords(lakh) + " Lakh "
      n %= 100000
    }

    const thousand = Math.floor(n / 1000)
    if (thousand > 0) {
      result += numberToWords(thousand) + " Thousand "
      n %= 1000
    }

    if (n > 0) {
      result += threeDigits(n) + " "
    }

    return result.trim()
  }

  return numberToWords(num)
}

export const fileSize = (size) => {
  if (size < 1024) {
    return `${size} bytes`
  } else if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(2)} KB`
  } else {
    return `${(size / (1024 * 1024)).toFixed(2)} MB`
  }
}

export const checkExtension = (filename) => {
  const parts = filename.split(".")
  if (parts.length > 1 && !filename.startsWith(".")) {
    return parts.pop().toLowerCase()
  }
  return ""
}

export const getDateOfRepayment = (val) => {
  const date = moment(val).format("D MMM YYYY")
  return date
}

export const getFundRequirementDate = (val) => {
  const date = moment(val).format("D MMM YYYY")
  return date
}

export const getIcdsStatus = (key) => {
  let status = "Active"
  let className = "Active"

  switch (key) {
    case "OPEN":
      status = "Open"
      className = "approved"
      break

    case "EXPIRED":
      status = "Expired"
      className = "link_expired"
      break

    case "CLOSED":
      status = "Closed"
      className = "counteroffer"
      break
  }

  return (
    <div className={`badge ${className}`}>
      <span></span> {status}
    </div>
  )
}

export const getIcdRequestStatus = (key) => {
  let status = "Active"
  let className = "Active"

  switch (key) {
    case "OPEN":
      status = "Open"
      className = "approved"
      break

    case "DIRECT_ACCEPTANCE":
      status = "Direct Acceptance"
      className = "directaccept"
      break

    case "COUNTER_OFFER":
      status = "Counter Offer"
      className = "counteroffer"
      break

    case "REJECTED":
      status = "Rejected"
      className = "rejected"
      break

    case "TERM_SHEET_SHARED":
      status = "Term Sheet Shared"
      className = "directaccept"
      break

    case "TERM_SHEET_FINALISED":
      status = "Term Sheet Finalised"
      className = "counteroffer"
      break

    case "FUNDS_IN_PROCESS":
      status = "Funds in process"
      className = "query_raised"
      break

    case "ONGOING":
      status = "Ongoing"
      className = "counteroffer"
      break

    case "EXPIRED":
      status = "Expired"
      className = "link_expired"
      break

    default:
      status = "Redeemed"
      className = "approved"
      break
  }

  return (
    <div className={`badge ${className}`}>
      <span></span> {status}
    </div>
  )
}
export const getInvoiceStatus = (key) => {
  let status = "Active"
  let className = "Active"

  switch (key) {
    case "PROCESSING":
      status = "Processing"
      className = "under_review"
      break

    case "REJECTED":
      status = "Rejected"
      className = "rejected"
      break

    default:
      status = "Approved"
      className = "approved"
      break
  }

  return (
    <div className={`badge ${className}`}>
      <span></span> {status}
    </div>
  )
}

export const getICDAgreementsStatus = (key) => {
  let status = "Active"
  let className = "Active"

  switch (key) {
    case "TERM_SHEET_SHARED":
      status = "Term Sheet Shared"
      className = "directaccept"
      break

    case "PENDING":
      status = "Pending"
      className = "under_review"
      break

    case "REJECTED":
      status = "Rejected"
      className = "rejected"
      break

    default:
      status = "Executed"
      className = "approved"
      break
  }

  return (
    <div className={`badge ${className}`}>
      <span></span> {status}
    </div>
  )
}

export const getInvestorsStatus = (key, deleted_at = null) => {
  if (deleted_at) {
    return (
      <div className={`badge rejected`}>
        <span></span>{" "}
        {moment().diff(moment(deleted_at), "days") > 30
          ? "Deleted"
          : "Deletion in Progress"}
      </div>
    )
  }
  let status = "Active"
  let className = "Active"
  switch (key) {
    case "LINK_SENT":
      status = "Link Sent"
      className = "link_sent"
      break

    case "LINK_EXPIRED":
      status = "Link Expired"
      className = "link_expired"
      break

    case "KYC_PENDING":
      status = "KYC Pending"
      className = "kyc_pending"
      break

    case "UNDER_REVIEW":
      status = "Under Review"
      className = "under_review"
      break

    case "QUERY_RAISED":
      status = "Query Raised"
      className = "query_raised"
      break

    case "REJECTED":
      status = "Rejected"
      className = "rejected"
      break

    case "DELETED":
      status = "Deleted"
      className = "rejected"
      break

    case "ICD_AGREEMENT":
      status = "Agreement Shared"
      className = "counteroffer"
      break

    case "INVESTED":
      status = "Invested"
      className = "approved"
      break

    case "ONBOARDING":
      status = "Onboarding"
      className = "counteroffer"
      break

    default:
      status = "Approved"
      className = "approved"
      break
  }

  return (
    <div className={`badge ${className}`}>
      <span></span> {status}
    </div>
  )
}

export const getAdminsStatus = (key) => {
  let status = "Active"
  let className = "Active"
  switch (key) {
    case "LINK_SENT":
      status = "Link Sent"
      className = "link_sent"
      break

    case "LINK_EXPIRED":
      status = "Link Expired"
      className = "link_expired"
      break

    case "BLOCKED":
      status = "Blocked"
      className = "rejected"
      break

    case "ICD_AGREEMENT":
      status = "ICD Agreement"
      className = "counteroffer"
      break

    default:
      status = "Active"
      className = "approved"
      break
  }

  return (
    <div className={`badge ${className}`}>
      <span></span> {status}
    </div>
  )
}

export const addSpaceEveryNChars = (str, interval = 4) => {
  if (!str) return ""
  return str.match(new RegExp(`.{1,${interval}}`, "g")).join(" ")
}

export const sweetAlertClasses = {
  popup: "swal2-small-popup",
  container: "swal2-small-container",
  title: "swal2-small-title",
  icon: "swal2-small-icon",
  htmlContainer: "swal2-small-html",
  actions: "swal2-small-actions",
  confirmButton: "swal2-small-confirm-button",
}

export const getTableSortingHeaderIcon = (column, name) => {
  const isSorted = column.getIsSorted()
  return (
    <div
      className="d-flex align-items-center justify-content-center gap-2 cursor-pointer arrow-section cp"
      onClick={() => column.toggleSorting()}
    >
      {name}
      <img
        src={arrowDown}
        height={15}
        className={isSorted !== "asc" ? "arrow-up" : "arrow-down"}
        alt=""
      />
    </div>
  )
}

export const toCapital = (str) => {
  if (str) return str.charAt(0).toUpperCase() + str.slice(1)
}

export const sanitizeIntegerInput = (e, setFieldValue, fieldName) => {
  let value = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1")
  setFieldValue(fieldName, value)
}

export const sanitizeIntegerInputReactHookForm = (e, onChange) => {
  let value = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1")
  onChange(value)
}
export const getAbbreviation = (name) => {
  if (!name) return ""

  return name
    .split(" ")
    .filter(Boolean)
    .map((word) => word[0])
    .filter((char) => /[a-z]/i.test(char))
    .join("")
    .substring(0, 2)
    .toUpperCase()
}

export const getOrdinal = (n) => {
  const s = ["th", "st", "nd", "rd"]
  const v = n % 100
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`
}

export function maskPhone(value) {
  const digits = String(value).replace(/\D/g, "") // keep only numbers
  if (digits.length <= 4) return digits
  return digits.slice(0, 2) + "x".repeat(digits.length - 4) + digits.slice(-2)
}

export const designationMap = {
  "Private Limited Company": ["Director", "Authorised Person"],
  "Public Limited Company": ["Director", "Authorised Person"],
  "One Person Company": ["Director", "Authorised Person"],
  "Sole Proprietorship": ["Proprietor", "Authorised Person"],
  "Partnership Firm": ["Partner", "Authorised Person"],
  "Limited Liability Partnership": [
    "Designated Partner",
    "Partner",
    "Authorised Person",
  ],
  "Hindu Undivided Family": ["Karta", "Authorised Person"],
  "Co-operative Society": ["Authorised Person"],
  "Trust/Association of Persons": ["Trustee", "Authorised Person"],
}

export const renderAddressValue = (data) => {
  let address = ""
  const addressOne = data?.address_one
  const addressTwo = data?.address_two
  const addressThree = data?.address_three
  const city = data?.city
  const state = data?.state
  const pinCode = data?.pin_code

  if (addressOne) {
    address = address.concat(addressOne, " ")
  }
  if (addressTwo) {
    address = address.concat(addressTwo, " ")
  }
  if (addressThree) {
    address = address.concat(addressThree, " ")
  }
  if (city) {
    address = address.concat(city, " ")
  }
  if (state) {
    address = address.concat(state, " ")
  }
  if (pinCode) {
    address = address.concat(pinCode)
  }

  return address
}

export const getBusinsessAddress = (address) => {
  let company_address = address?.business_address || ""
  if (!company_address) {
    company_address = renderAddressValue(address)
  }
  return company_address
}

export const showRegistrationType = (businessType) => {
  if (
    businessType === "Private Limited Company" ||
    businessType === "Public Limited Company" ||
    businessType === "One Person Company"
  )
    return "CIN"
  else if (businessType === "Limited Liability Partnership") return "LLPIN"
  else return null
}
export const handleDownload = async (fileUrl, filename) => {
  try {
    const baseUrl = process.env.REACT_APP_API_URL
    const finalUrl = `${baseUrl}/public/downloadFile`

    if (!fileUrl) return null
    const response = await fetch(finalUrl, {
      method: "POST",
      body: JSON.stringify({ fileUrl }),
      headers: {
        "Content-Type": "application/json",
      },
    })
    if (!response.ok) throw new Error("Download failed")

    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)

    const a = document.createElement("a")
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
  } catch (err) {
    console.error(err)
  }
}

export const exportToExcel = async (endpoint, params = {}, filename) => {
  try {
    const baseUrl = process.env.REACT_APP_API_URL

    const queryString = new URLSearchParams(params).toString()
    const finalUrl = `${baseUrl}${endpoint}${queryString ? `?${queryString}` : ""}`

    const state = store.getState()
    const token = state.user?.jwt

    const response = await fetch(finalUrl, {
      method: "GET",
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        Authorization: `Bearer ${token}`,
      },
    })

    if (!response.ok) throw new Error(`Download failed: ${response.statusText}`)

    const blob = await response.blob()
    const fileUrl = window.URL.createObjectURL(blob)

    const a = document.createElement("a")
    a.href = fileUrl
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()

    window.URL.revokeObjectURL(fileUrl)
  } catch (err) {
    console.error("❌ Excel export failed:", err)
  }
}
export const urlToFile = async (fileUrl, fileName) => {
  const baseUrl = process.env.REACT_APP_API_URL
  const finalUrl = `${baseUrl}/public/downloadFile`

  console.log("response.ok", fileUrl)
  if (!fileUrl) return null
  const response = await fetch(finalUrl, {
    method: "POST",
    body: JSON.stringify({ fileUrl }),
    headers: {
      "Content-Type": "application/json",
    },
  })
  console.log(response.ok)

  if (!response.ok) throw new Error("Preview failed")
  const blob = await response.blob()

  const fileType = blob.type

  return new File([blob], fileName, { type: fileType })
}
export const businessTypes = (userType = "INVESTOR") => {
  let types = ["Private Limited Company", "Public Limited Company"]
  if (userType === "WEALTH_PARTNER") {
    types = [
      ...types,
      // "One Person Company",
      // "Sole Proprietorship",
      "Limited Liability Partnership",
      "Partnership Firm",
      "Hindu Undivided Family",
      // "Co-operative Society",
      // "Trust/Association of Persons",
    ]
  }
  return types
}
